import { useMutation } from "react-query";
import { deactivateScoreCard } from "../../../../actions/CarrierAgreementMgmt/ScoreCard";

const useDeactivateScoreCard = () => {
  return useMutation(deactivateScoreCard);
};
export default useDeactivateScoreCard;
